import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

export default function Section1JP() {
    const { t } = useLang('dp3.landing.section1');

    return (
        <div className={`page-section1JP ${styles.Section1JP} GtmModuleData-section`} data-section-id={'dp3-Section1JP'} data-section-title={t('title')}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.Section1JP}`}>
                <div className="content">
                    <EfImg
                        className="img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1749694360708/pc_bg.png"
                        // pad="https://websiteoss.ecoflow.com/upload/image/1749694360556/m_bg.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1749694360556/m_bg.png"
                    />
                </div>
            </div>
        </div>
    );
}
